import {IDBPDatabase, IDBPTransaction, StoreNames} from 'idb';

import {globalThis} from '../../libs/shared/helpers/src/browser/globalThis';

/**
 * Helpers for the `idb` npm module.
 */

export function safeDeleteStore<SCHEMA>(name: StoreNames<SCHEMA>, db: IDBPDatabase<SCHEMA>) {
  if (Array.from(db.objectStoreNames).includes(name)) {
    db.deleteObjectStore(name);
  }
}

export function clearOrCreateStore<SCHEMA, Mode extends Exclude<IDBTransactionMode, 'readonly'>>(
  name: StoreNames<SCHEMA>,
  db: IDBPDatabase<SCHEMA>,
  tx: IDBPTransaction<SCHEMA, StoreNames<SCHEMA>[], Mode>,
) {
  if (Array.from(db.objectStoreNames).includes(name)) {
    tx.objectStore(name).clear();
  } else {
    db.createObjectStore(name);
  }
}

export async function migrateStoreData<SCHEMA, Mode extends Exclude<IDBTransactionMode, 'readonly'>>(
  storeName: StoreNames<SCHEMA>,
  tx: IDBPTransaction<SCHEMA, StoreNames<SCHEMA>[], Mode>,
  transformData: (oldData: unknown) => unknown | undefined,
) {
  let cursor = await tx.objectStore(storeName).openCursor();
  while (cursor) {
    const newData = transformData(cursor.value) as any;
    if (newData) {
      cursor.update(newData);
    } else {
      cursor.delete();
    }

    // eslint-disable-next-line no-await-in-loop
    cursor = await cursor.continue();
  }
}

export function isQuotaExceededError(maybeError: unknown) {
  return (
    'DOMException' in globalThis &&
    maybeError instanceof DOMException &&
    maybeError.code === DOMException.QUOTA_EXCEEDED_ERR
  );
}

export function isDatabaseClosingError(maybeError: unknown) {
  return (
    'DOMException' in globalThis &&
    maybeError instanceof DOMException &&
    maybeError.name === 'InvalidStateError' &&
    maybeError.message ===
      "Failed to execute 'transaction' on 'IDBDatabase': The database connection is closing."
  );
}

export function isAbortError(maybeError: unknown) {
  return (
    'DOMException' in globalThis && maybeError instanceof DOMException && maybeError.name === 'AbortError'
  );
}
